import { render, staticRenderFns } from "./GroupContextMenu.vue?vue&type=template&id=480072ab&scoped=true&"
import script from "./GroupContextMenu.vue?vue&type=script&lang=js&"
export * from "./GroupContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupContextMenu.vue?vue&type=style&index=0&id=480072ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480072ab",
  null
  
)

export default component.exports